
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-4b122b0a\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./mini-ooo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./mini-ooo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-4b122b0a\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./mini-ooo.vue"),
  /* scopeId */
  "data-v-4b122b0a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/mini-ooo.vue
// module id = 558
// module chunks = 0